import React from 'react';

type OurBetComponentProps = {
  children: JSX.Element;
};

function OurBet({ children }: OurBetComponentProps) {
  return <div className="ourBet__route">{children}</div>;
}

export default OurBet;
